<template>
  <div
    class="cpt-chat-switch-button flex-center h-[30px] p-[2px] w-[200px] relative rounded-[5px] bg-op-1"
    :class="[{'big': size === 'big'}, {'has-devider': devider}]"
  >
    <div
      class="choose-slider h-[26px] rounded-[3px] bg-bd-fl absolute left-[2px] top-[2px] pointer-events-none"
      v-if="activeIndex > -1"
      :style="{
        width: sliderWidth,
        transform: `translateX(${activeIndex * 100}%)`,
      }"
    ></div>
    <div
      class="option-btn flex-center"
      :class="{
        active: value === item.value
      }"
      v-for="item in options"
      :key="item.value"
      @click="value !== item.value && $emit('change', item.value)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatSwitchButton',
  props: {
    options: {
      default: () => [],
      type: Array,
    },
    value: {
      default: null,
    },
    size: {
      default: "small",
      type: String,
    },
    devider: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      PADDING_LENGTH: 2,
    }
  },
  computed: {
    activeIndex() {
      return this.options.findIndex(({ value }) => value === this.value)
    },
    sliderWidth() {
      return `calc(${(100 / this.options.length).toFixed(2)}% - ${2 * this.PADDING_LENGTH / this.options.length}px)`
    },
  },
}
</script>
<style lang="scss">
.cpt-chat-switch-button {
  &.big {
    @include size(100%, 42px);
    .choose-slider {
      height: 38px;
    }
    .option-btn {
      width: 100%;
      flex-shrink: 1; 
      display: block;
      position: relative;
      line-height: 38px;
      text-align: center;
    }
  }
  &.has-devider {
    .option-btn {
      &:not(:last-child)::after {
        content: "";
        @include size(1px, 16px);
        position: absolute;
        left: 100%;
        top: 50%;
        transform: translateY(-50%);
        background-color: $d-op-2;
      }
    }
  }
  .option-btn {
    height: 100%;
    width: 0;
    flex: 1;
    color: $d-op-4;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.12px;
    z-index: 1;
    cursor: pointer;
    position: relative;
    &.active {
      color: $ct-wh-0;
      transition: color .2s ease-in-out;
    }
  }
  .choose-slider {
    transition: transform .2s ease-in-out;
  }
}
</style>
